import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useSubtleIcon } from 'kineticUtils';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';

const inheritFont = {
  font: 'inherit',
  letterSpacing: 'inherit',
};

const useEditableTitleStyles = makeStyles(({ spacing, palette }) => {
  const { subtleIcon } = useSubtleIcon(palette);
  return createStyles({
    editableWrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      height: '1em',
      overflow: 'visible',
    },
    textField: {
      width: '15em',
    },
    inputRoot: {
      ...inheritFont,
      [`& .${outlinedInputClasses.notchedOutline}`]: {
        borderLeft: 'none',
        borderRight: 'none',
        borderTop: 'none',
      },
      [`& .${outlinedInputClasses.input}`]: {
        padding: `${spacing(0.6)} 0`,
      },
    },
    focusedInputRoot: {
      ...inheritFont,
      [`& .${outlinedInputClasses.notchedOutline}`]: {
        outline: `${palette.primary.main} solid 3px`,
        border: 'none',
      },
      [`& .${outlinedInputClasses.input}`]: {
        padding: spacing(),
        paddingTop: 0,
      },
    },
    editIcon: {
      marginLeft: spacing(),
    },
    buttonWrapper: {
      ...inheritFont,
    },
    button: {
      marginLeft: spacing(),
      ...inheritFont,
    },
    subtleIcon,
  });
});

export default useEditableTitleStyles;
